module.exports = __webpack_public_path__ + "static/matza_4@2x-7506c06e3fbb3f1f09943711759f387b.jpg";